// @generated by protoc-gen-connect-es v1.4.0
// @generated from file penumbra/core/component/stake/v1/stake.proto (package penumbra.core.component.stake.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CurrentValidatorRateRequest, CurrentValidatorRateResponse, GetValidatorInfoRequest, GetValidatorInfoResponse, ValidatorInfoRequest, ValidatorInfoResponse, ValidatorPenaltyRequest, ValidatorPenaltyResponse, ValidatorStatusRequest, ValidatorStatusResponse, ValidatorUptimeRequest, ValidatorUptimeResponse } from "@buf/penumbra-zone_penumbra.bufbuild_es/penumbra/core/component/stake/v1/stake_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Query operations for the staking component.
 *
 * @generated from service penumbra.core.component.stake.v1.QueryService
 */
export const QueryService = {
  typeName: "penumbra.core.component.stake.v1.QueryService",
  methods: {
    /**
     * Queries for information about a specific validator.
     *
     * @generated from rpc penumbra.core.component.stake.v1.QueryService.GetValidatorInfo
     */
    getValidatorInfo: {
      name: "GetValidatorInfo",
      I: GetValidatorInfoRequest,
      O: GetValidatorInfoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Queries the current validator set, with filtering.
     *
     * @generated from rpc penumbra.core.component.stake.v1.QueryService.ValidatorInfo
     */
    validatorInfo: {
      name: "ValidatorInfo",
      I: ValidatorInfoRequest,
      O: ValidatorInfoResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc penumbra.core.component.stake.v1.QueryService.ValidatorStatus
     */
    validatorStatus: {
      name: "ValidatorStatus",
      I: ValidatorStatusRequest,
      O: ValidatorStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc penumbra.core.component.stake.v1.QueryService.ValidatorPenalty
     */
    validatorPenalty: {
      name: "ValidatorPenalty",
      I: ValidatorPenaltyRequest,
      O: ValidatorPenaltyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc penumbra.core.component.stake.v1.QueryService.CurrentValidatorRate
     */
    currentValidatorRate: {
      name: "CurrentValidatorRate",
      I: CurrentValidatorRateRequest,
      O: CurrentValidatorRateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc penumbra.core.component.stake.v1.QueryService.ValidatorUptime
     */
    validatorUptime: {
      name: "ValidatorUptime",
      I: ValidatorUptimeRequest,
      O: ValidatorUptimeResponse,
      kind: MethodKind.Unary,
    },
  }
};

